import { customer_module_names } from './CustomerModuleNamesInDB';

export interface CustomRouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  extralink: boolean;
  submenu: CustomRouteInfo[];
  module_name: string;
}

export const CUSTOMER_ROUTES: CustomRouteInfo[] = [
  {
    path: '',
    title: '',
    icon: 'mdi mdi-view-dashboard',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/customer/dashboard',
        title: 'Dashboard',
        icon: 'mdi mdi-information',
        class: '',
        extralink: false,
        submenu: [],
        module_name: customer_module_names.dashboard_module,
      },
    ],
    module_name: customer_module_names.dashboard_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-account-settings',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/customer/profile',
        title: 'Company Profile',
        icon: 'mdi mdi-account',
        class: '',
        extralink: false,
        submenu: [],
        module_name: customer_module_names.profile_module,
      },
    ],
    module_name: customer_module_names.profile_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-account-multiple',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/customer/manage-users',
        title: 'Users',
        icon: 'mdi mdi-account-settings-outline',
        class: '',
        extralink: false,
        submenu: [],
        module_name: customer_module_names.users_module,
      },
    ],
    module_name: customer_module_names.users_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-cogs',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/customer/my-subscription',
        title: 'Subscription',
        icon: 'mdi mdi-clipboard-text',
        class: '',
        extralink: false,
        submenu: [],
        module_name: customer_module_names.subscription_module,
      },
    ],
    module_name: customer_module_names.subscription_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-file-document',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/customer/my-invoices',
        title: 'Billing',
        icon: 'mdi mdi-file-document-outline',
        class: '',
        extralink: false,
        submenu: [],
        module_name: customer_module_names.invoice_module,
      },
    ],
    module_name: customer_module_names.invoice_module,
  },
  {
    path: '',
    title: '',
    icon: 'mdi mdi-ticket-account',
    class: '',
    extralink: false,
    submenu: [
      {
        path: '/customer/support-ticket',
        title: 'Support Ticket',
        icon: 'mdi mdi-ticket-account',
        class: '',
        extralink: false,
        submenu: [],
        module_name: customer_module_names.support_ticket_module,
      },
    ],
    module_name: customer_module_names.support_ticket_module,
  },
  // {
  //   path: '',
  //   title: '',
  //   icon: 'mdi mdi-credit-card',
  //   class: '',
  //   extralink: false,
  //   submenu: [
  //     {
  //       path: '/customer/payment',
  //       title: 'Payment',
  //       icon: 'mdi mdi-credit-card-scan',
  //       class: '',
  //       extralink: false,
  //       submenu: [],
  //       module_name: customer_module_names.payment_module,
  //     },
  //   ],
  //   module_name: customer_module_names.payment_module,
  // },
];
